export const patentTableOfClusterDetail = {
    singleSort: '*You can sort a single column by clicking its header.',
    ipcCodeAreaText: 'Search by IPC code',
    searchAll: 'Search all',
    userInputPlaceholder: 'Please enter a keyword',
    clusterId: 'Cluster ID',
    publicationNumber: 'Publication Number',
    mainIpc: 'Main IPC',
    otherIpc: 'Other IPC',
    title: 'Title',
    patentOwner: 'Patent Owner',
    inventor: 'Inventor',
    factorLoadQuantity: 'Factor Load Quantity',
    forwardCitations: 'Forward Citations',
    applicationYear: 'Application Year',
    materialPatent: 'Material Patent'
}
